<template>
    <div class="col-md-12">
        <div class="block">
            <div v-if="!dataWorking.length" class="text-center">Chưa có dữ liệu</div>
            <div v-else>
                <el-timeline >
                    <el-timeline-item v-for="(item, idx) in dataWorking"
                                      :key="`${idx}`"
                                      :color="item.status ? '#3f1889' : '' "
                                      placement="top"
                                      type="primary"
                                      :timestamp="item.career_date"
                    >
                        <div style="background-color: #FFFFFF;" class="p-2 rounded shadow mr-2 col-md-6">
                            <div class="col-md-12 row">
                                <div class="col-md-6 mt-3">
                                    <p>
                                        Vị trí: <span style="font-weight: bold">{{ convertJson(item.data).vi_tri }}</span>
                                    </p>
                                    <p>
                                        Phòng ban/ Vùng: <span style="font-weight: bold">{{ convertJson(item.data).phongban_vung }}</span>
                                    </p>
                                    <p>
                                        Nhóm/ Văn Phòng: <span style="font-weight: bold">{{ convertJson(item.data).nhom_van_phong }}</span>
                                    </p>
                                    <p>
                                        Level quản trị: <span style="font-weight: bold">{{ convertJson(item.data).level_quan_tri }}</span>
                                    </p>
                                    <p>
                                        Thâm niên làm việc: <span style="font-weight: bold">{{ convertJson(item.data).tham_nien_tai_vi_tri }}</span>
                                    </p>
                                </div>
                                <div class="col-md-6">
                                    <p>
                                        Chức danh: <span style="font-weight: bold">{{ convertJson(item.data).bo_phan_khu_vuc }}</span>
                                    </p>
                                    <p>
                                        Level chuyên môn: <span style="font-weight: bold">{{ convertJson(item.data).level_chuyen_mon }}</span>
                                    </p>
                                    <p>
                                        Thâm niên tại vị trí: <span style="font-weight: bold">{{ convertJson(item.data).level_chuyen_mon }}</span>
                                    </p>
                                    <p>
                                        Hình thức: <span style="font-weight: bold">{{ convertJson(item.data).hinh_thuc }}</span>
                                    </p>
                                    <p>
                                        Khối : <span style="font-weight: bold">{{ convertJson(item.data).khoi }}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </el-timeline-item>
                </el-timeline>
            </div>
        </div>
    </div>
</template>

<script>
import {GET_WORKING_PROCESS} from "../../../../core/services/store/profile.module";
import {mapGetters, mapState} from "vuex";

export default {
    name: "WorkingProcess",
    data()
    {
        return {
        }
    },
    props: {
        dataWorking: {
            type: Array,
            default: () => { return [] }
        }
    },
    mounted() {
    },
    methods: {
        convertJson(data)
        {
            let newObj = {};
            Object.keys(data).forEach(k => {
                let newKey = k.replace(/\//g, "_");
                newObj[newKey] = data[k];
            });
            return newObj;
        }

    },
}
</script>

<style scoped>
    .bg-violet {
        background-color: #5E00B6;
    }
</style>